import * as React from "react";
import type { SVGProps } from "react";
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cross_svg__a)">
      <path d="M3 22c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l18-18.01A.996.996 0 1 1 21.7 3.7L3.71 21.71c-.2.2-.45.29-.71.29" />
      <path d="M21 22c-.26 0-.51-.1-.71-.29l-18-18c-.39-.39-.39-1.03 0-1.42s1.03-.39 1.42 0l18 18a.996.996 0 0 1-.71 1.7z" />
    </g>
    <defs>
      <clipPath id="cross_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCross;
